import { render } from "./EnrollmentFallback.vue?vue&type=template&id=53c378ce&scoped=true"
import script from "./EnrollmentFallback.vue?vue&type=script&lang=js"
export * from "./EnrollmentFallback.vue?vue&type=script&lang=js"

import "./EnrollmentFallback.vue?vue&type=style&index=0&id=53c378ce&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c378ce"]])

export default __exports__